var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0827 1.75H2.91602C2.09106 1.75 1.67858 1.75 1.4223 1.99045C1.16602 2.2309 1.16602 2.61789 1.16602 3.39189V3.79428C1.16602 4.39969 1.16602 4.70239 1.31745 4.95333C1.46888 5.20426 1.74554 5.36 2.29886 5.67149L3.99812 6.62806C4.36937 6.83704 4.55499 6.94153 4.6879 7.05692C4.96467 7.29721 5.13506 7.57955 5.21227 7.92585C5.24935 8.09214 5.24935 8.28672 5.24935 8.67588L5.24935 10.2331C5.24935 10.7636 5.24935 11.0289 5.3963 11.2357C5.54326 11.4426 5.80426 11.5446 6.32627 11.7487C7.42214 12.1771 7.97007 12.3913 8.35971 12.1476C8.74935 11.9038 8.74935 11.3469 8.74935 10.2331V8.67588C8.74935 8.28672 8.74935 8.09214 8.78643 7.92585C8.86364 7.57955 9.03402 7.29721 9.3108 7.05692C9.44371 6.94153 9.62933 6.83704 10.0006 6.62806L11.6998 5.67149C12.2532 5.36 12.5298 5.20426 12.6812 4.95333C12.8327 4.70239 12.8327 4.39969 12.8327 3.79428V3.39189C12.8327 2.61789 12.8327 2.2309 12.5764 1.99045C12.3201 1.75 11.9076 1.75 11.0827 1.75Z",
    stroke: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.e52cfcf894404c29d25c8f497067cc0c.svg";
export { ForwardRef as ReactComponent };